import { render, staticRenderFns } from "./_PlanoTable.vue?vue&type=template&id=1c48e382"
import script from "./_PlanoTable.vue?vue&type=script&lang=ts"
export * from "./_PlanoTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports